import axios from 'axios';
import config from 'util/config';
import { getCookieValue } from 'util/Common'

export default function apiCaller(endpoint, method = 'GET', body) {
  const accessToken = getCookieValue('accessTokensct');
  if (accessToken) {
    return axios({
      method: method,
      url: `${config.API_URL}/${endpoint}`,
      data: body,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': 'Bearer '.concat(accessToken)
      }
    }).catch(err => err.response);
  }
};